import { __assign } from "tslib";
import { connect } from 'react-redux';
import { selectors, actions } from '../redux';
import { getSelectedFolderIds } from '../redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviationId = _a.collectibleDeviation.deviationId;
    return (__assign(__assign({}, selectors.getUserCollections(state, deviationId)), { selectedFolderIds: getSelectedFolderIds(state, deviationId) }));
};
var mapDispatchToProps = {
    toggleCollection: actions.toggleCollection,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CollectionList.container.js.map